// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createCustomError } from "@nevware21/ts-utils";
import { _DYN_LENGTH } from "../../../__DynamicConstants";
import { STR_EMPTY } from "../../../constants/InternalConstants";
import { getOpenTelemetryError } from "./OTelError";
var otelSpanErrorType;
export function throwOTelSpanError(message, spanName) {
    if (!otelSpanErrorType) {
        otelSpanErrorType = createCustomError("OTelSpanError", function (self, args) {
            var len = args[_DYN_LENGTH /* @min:%2elength */];
            self.spanName = len > 1 ? args[1] : STR_EMPTY;
        }, getOpenTelemetryError());
    }
    throw new otelSpanErrorType(message, spanName);
}
//# sourceMappingURL=OTelSpanError.js.map